import React, { Component } from 'react';
import RouteTitle from '../../../shared/route-title/RouteTitle';
import SimpleTable from '../../../shared/table/SimpleTable';
import CheckBox from '../../../shared/checkbox/CheckBox';
import { connect } from 'react-redux';
import { getCurrentWorkOrder } from '../../../../selectors/admin/work-orders/work-orders';
import SearchBar from '../../../shared/navigation/SearchBar';
import {
  getClients,
  getSelectedClientId,
} from '../../../../selectors/admin/work-orders/creation/clients';
import {
  goToBuildingSelection,
  loadClientsRequest,
  setClient,
} from '../../../../actions/admin/work-orders/creation/clients';

class ClientSelection extends Component {
  componentDidMount() {
    if (this.props.currentWorkOrder !== null) {
      this.props.dispatch(setClient(this.props.currentWorkOrder.client.id));
    }
    this.props.dispatch(loadClientsRequest());
  }

  handleCheckboxChange = (clientId) => {
    this.props.dispatch(setClient(clientId));
    this.props.dispatch(goToBuildingSelection());
  };

  render() {
    return (
      <div className="building-selection">
        <RouteTitle
          titles={[
            'WORK ORDERS',
            this.props.currentWorkOrder === null
              ? 'CREATE NEW'
              : 'WO #' + this.props.currentWorkOrder.number,
          ]}
        />

        <SearchBar>
          <span className="navbar-text">
            Which Client is the Work Order for?
          </span>
        </SearchBar>

        <div className="content-container">
          <SimpleTable
            headers={['', 'COMPANY NAME', 'CONTACT']}
            rows={this.mapClients(this.props.clients)}
            emptyMessage="No Clients"
          />
        </div>
      </div>
    );
  }

  mapClients = (clients) => {
    return clients.map((client) => {
      return [
        <CheckBox
          id={client.id}
          checked={client.id === this.props.selectedClientId}
          shape={'round'}
          size={'medium'}
          onChange={this.handleCheckboxChange}
        />,
        <span className="h4">{client.company_name}</span>,
        `${client.contact.first_name} ${client.contact.last_name}`,
      ];
    });
  };
}

export default connect((state) => {
  return {
    clients: getClients(state),
    currentWorkOrder: getCurrentWorkOrder(state),
    selectedClientId: getSelectedClientId(state),
  };
})(ClientSelection);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/creation/ClientSelection.js